import { CanDeactivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PricingmatrixComponent } from './pricingmatrix.component';

export const PriceMatrixNavGuard: CanDeactivateFn<PricingmatrixComponent> =
(component: PricingmatrixComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
  return component.checkNavGuard(nextState.url);
};
